<script>
import { Doughnut } from "vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";
//https://chartjs-plugin-datalabels.netlify.app/
export default {
  extends: Doughnut,
  name: "Doughnut",
  props: ["doughnutData", "doughnutDataFake"],
  computed:{
    innerDoughnut() {
      return function () {
        let array = this.doughnutData;
        let array2 = this.doughnutDataFake;
        let dataR = [ array[0] , (array[1] + array[2] +array[3] +array[4])];
        let dataF = [ array2[0] , (array2[1] + array2[2] +array2[3] +array2[4])];
        let data = [dataR,dataF];

        console.log(data);
        return data;
      };
    },
  },  
  mounted() {
    let real = this.doughnutData;
    let real2 = this.doughnutDataFake;
    let cc = 0;
    let cText;
    let cc2 = 0;
    let innerDR = [ real[0] , (real[1] + real[2] +real[3] +real[4])];
    let innerDF = [ real2[0] , (real2[1] + real2[2] +real2[3] +real2[4])];
    this.renderChart(
      {
        datasets: [
          {
            type: "doughnut",
            data: this.doughnutDataFake,
            // data: this.doughnutData,
            backgroundColor: [
              "rgba(23,136,221,1)",
              "rgba(239,59,141,1)",
              "rgba(239,109,63,1)",
              "rgba(227,225,0,1)",
              "rgba(0,170,159,1)",
            ],
            // label: "転職回数",
            // labels: ["0回", "1回", "2回", "3回", "4回〜"],
            plugins: [ChartDataLabels],
            datalabels: {
              color: ["white", "white", "white", "black", "white"],
              //formatter: function (value, context) {
              formatter: function () {
                cc++;
                // console.log(value);
                // 正確なデータは以下の方法で。(要調整)
                // let labelPtext = this.doughnutData;
                // return (
                //   context.chart.data.labels[context.dataIndex] +
                //   "\n" +
                //   value +
                //   "%"
                // );
                if ( cc == 5){
                  cText = "4回以上";
                }else{
                  cText = cc-1 + "回";
                }
                return (
                  cText + "\n" + real[cc-1] + "%"
                );                
              },
            },
          },
          {
            type: "doughnut",
            data: innerDF,
            backgroundColor: ["rgba(23,136,221,1)", "rgba(239,59,141,1)"],
            label: "転職経験",
            labels: ["無し", "有り"],
            datalabels: {
              color: "white",
              // 正しいデータはこちら。(要調整)
              // formatter: function (value, context) {
              //   let secLabel = ["無し", "有り"];
              //   return secLabel[context.dataIndex] + ":\n" + value + "%";
              //   //return secLabel[context.dataIndex] + ":\n" + "test" + "%";
              // },
              formatter: function () {
                cc2++;
                let secLabel = ["無し", "有り"];
                return secLabel[cc2-1] + ":\n" + innerDR[cc2-1] + "%";
                //return secLabel[context.dataIndex] + ":\n" + "test" + "%";
              },              
            },
          },
        ],
        labels: ["0回", "1回", "2回", "3回", "4回以上"],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 10,
        tooltips: {enabled:false},
        hover: {mode: null},
        legend: {display: false,},
      }
    );
  },
};
</script>